<template>
    <div>
        <h3>
            <AppEditable :value="invoice.document_type"
                         :errors="errors"
                         field="document_type"
                         :placeholder="$t('type_placeholder')"
                         @change="updateProp({ document_type: $event })"/>
            <AppEditable :value="invoice.number"
                         :errors="errors"
                         field="number"
                         :placeholder="$t('invoice_number')"
                         @change="updateProp({ number: $event })"/>
        </h3>
        {{ $t('issued_at') }}
        <span class="editable__item" v-b-modal.modal_issued_at>{{ invoice.issued_at | date('D. MMM YYYY', 'YYYY-MM-DD') }}</span>
        <BModal id="modal_issued_at"
                centered
                :title="$t('modal_issued_at_title')"
                hide-footer
                size="sm"
                content-class="bg-base dp--24">
            <AppDatePicker :value="invoice.issued_at"
                           @change="updateProp({ issued_at: $event })"
                           :errors="errors"
                           :inline="true"
                           field="issued_at"/>
        </BModal>
        <br>
        <AppEditable :value="invoice.due_at_label"
                     :errors="errors"
                     field="due_at_label"
                     :placeholder="$t('due_at')"
                     @change="updateProp({ due_at_label: $event })"/>
        <AppEditable :value="invoice.due_at"
                     :errors="errors"
                     field="due_at"
                     :placeholder="$t('modal_due_at_title')"
                     @change="updateProp({ due_at: $event })"/>

    </div>
</template>
<script>
import { BModal, VBModal } from 'bootstrap-vue';
import AppEditable from '@/components/form/AppEditable';
import AppDatePicker from '@/components/form/AppDatePicker';
import { formatDate } from '@/filters/date.filter';

export default {
  i18nOptions: { namespaces: 'invoice-header' },
  props: ['invoice', 'errors'],
  components: {
    AppEditable,
    AppDatePicker,
    BModal,
  },
  directives: {
    'b-modal': VBModal,
  },
  filters: {
    date: formatDate,
  },
  methods: {
    updateProp(props) {
      this.$emit('update', props);
    },
  },
};
</script>
